import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import SubPage from 'uikit/SubPage';
import Tabs from 'uikit/Tabs';

import QuestionImportCourse from './QuestionImportCourse';
import QuestionImportFile from './QuestionImportFile';
import QuestionImportList from './QuestionImportList';
import QuestionImportPublicCourses from './QuestionImportPublicCourses';
import QuestionImportWooclap from './QuestionImportWooclap';

import styles from './QuestionImport.module.scss';

const cx = classNames.bind(styles);

const QuestionImport = ({ course, handleModalClose, isModalOpen, t }) => (
  <SubPage
    isOpen={isModalOpen}
    onExit={handleModalClose}
    subtitle={course.title}
    title={t('Course/Teacher/Editor/QuestionImport/import')}
  >
    <div className={cx('subpage')}>
      <Tabs className={cx('tabs')}>
        <Tabs.Tab
          label={t('Course/Teacher/Editor/QuestionImport/from-public-courses')}
        >
          <QuestionImportPublicCourses course={course} />
        </Tabs.Tab>
        <Tabs.Tab label={t('Course/Teacher/Editor/QuestionImport/from-course')}>
          <QuestionImportCourse
            course={course}
            handleModalClose={handleModalClose}
          />
        </Tabs.Tab>
        <Tabs.Tab label={t('Course/Teacher/Editor/QuestionImport/from-file')}>
          <QuestionImportFile
            course={course}
            handleModalClose={handleModalClose}
          />
        </Tabs.Tab>
        <Tabs.Tab label={t('Course/Teacher/Editor/QuestionImport/from-list')}>
          <QuestionImportList
            course={course}
            handleModalClose={handleModalClose}
          />
        </Tabs.Tab>
        <Tabs.Tab
          label={t('Course/Teacher/Editor/QuestionImport/from-wooclap')}
        >
          <QuestionImportWooclap
            course={course}
            handleModalClose={handleModalClose}
          />
        </Tabs.Tab>
      </Tabs>
    </div>
  </SubPage>
);

QuestionImport.propTypes = {
  course: PropTypes.object.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
};

export default QuestionImport;
